<div class="container-margin">
  <h1 class="header">{{ title }}</h1>
  <form [formGroup]="templateForm">
    <div class="form-groups">
      <div class="form-group template-name">
        <mat-form-field appearance="outline">
          <mat-label>{{
            translationService.getCsvTemplateNameText()
          }}</mat-label>
          <input
            matInput
            type="text"
            name="templateName"
            formControlName="templateName"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>
      <div class="info-text form-group">
        <p>
          {{ translationService.getFieldMappingPromptText() }}
        </p>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getNameText() }}</mat-label>
          <input
            matInput
            type="text"
            name="name"
            formControlName="name"
            autocomplete="off"
            maxlength="255"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getOtherNamesText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="otherNames"
            autocomplete="off"
            maxlength="255"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ translationService.getCasNumbersText() }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="casNumbers"
            autocomplete="off"
            maxlength="255"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="actions">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getSubmitText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="onReset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </form>
</div>
